import { routeLinks } from "constants/paths";
import {
  ButtonLink,
  ErrorHeading,
  ErrorMessage,
  PageNotFoundContainer,
} from "./Styled";

export const Forbidden = () => {
  return (
    <PageNotFoundContainer>
      <ErrorHeading variant="h2">403 - Forbidden</ErrorHeading>
      <ErrorMessage variant="body1">
        The page you are looking for is not accessible by you.
      </ErrorMessage>
      <ButtonLink variant="contained" href={routeLinks.dashboardCommon}>
        Return to Homepage
      </ButtonLink>
    </PageNotFoundContainer>
  );
};
